"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionDropZoneBox = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var DashboardLayoutSectionBorder_1 = require("./DashboardLayoutSectionBorder");
exports.SectionDropZoneBox = function (props) {
    var isOver = props.isOver;
    return (react_1.default.createElement("div", { className: "new-row-dropzone" },
        react_1.default.createElement(DashboardLayoutSectionBorder_1.DashboardLayoutSectionBorder, { status: isOver ? "active" : "muted" },
            react_1.default.createElement("div", { className: classnames_1.default("drag-info-placeholder", "widget-dropzone-box", "s-last-drop-position", "type-kpi") },
                react_1.default.createElement("div", { className: classnames_1.default("drag-info-placeholder-inner", "can-drop", { "is-over": isOver }) },
                    react_1.default.createElement("div", { className: "drag-info-placeholder-drop-target" },
                        react_1.default.createElement("div", { className: "drop-target-inner" },
                            react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "p", className: "drop-target-message kpi-drop-target" },
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "dropzone.new.row.desc", values: {
                                        b: function (chunks) { return react_1.default.createElement("b", null, chunks); },
                                        nbsp: react_1.default.createElement(react_1.default.Fragment, null, "\u00A0"),
                                    } })))))))));
};
//# sourceMappingURL=SectionDropZoneBox.js.map